import { useState } from "react"
import { MoreHorizontal } from "lucide-react"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"

// Secondary row actions behind a compact "•••" trigger. The menu renders in a
// portal so it is never clipped by the table's horizontal scroller. `items` is
// [{ key, label, onClick }] — callers pass only the actions that already exist
// elsewhere (full page, vendor proposals, expand/collapse a group).
const OrderRowMenu = ({ items = [], label = "More actions" }) => {
  const [anchor, setAnchor] = useState(null)
  if (!items.length) return null

  const close = (e) => {
    e?.stopPropagation?.()
    setAnchor(null)
  }

  return (
    <>
      <button
        type="button"
        className="pc-row-menu-btn"
        aria-label={label}
        aria-haspopup="menu"
        aria-expanded={!!anchor}
        onClick={(e) => {
          e.stopPropagation()
          setAnchor(e.currentTarget)
        }}
      >
        <MoreHorizontal size={16} aria-hidden />
      </button>
      <Menu
        anchorEl={anchor}
        open={!!anchor}
        onClose={close}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ className: "pc-row-menu" }}
      >
        {items.map((it) => (
          <MenuItem
            key={it.key}
            onClick={(e) => {
              close(e)
              it.onClick()
            }}
          >
            {it.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default OrderRowMenu
